package ru.chm.gradereport.ui.screens.course.sheet

import androidx.compose.foundation.background
import androidx.compose.foundation.border
import androidx.compose.foundation.clickable
import androidx.compose.foundation.layout.Box
import androidx.compose.foundation.layout.height
import androidx.compose.foundation.layout.padding
import androidx.compose.foundation.layout.requiredWidth
import androidx.compose.foundation.shape.RoundedCornerShape
import androidx.compose.material3.Text
import androidx.compose.runtime.Composable
import androidx.compose.ui.Alignment
import androidx.compose.ui.Modifier
import androidx.compose.ui.draw.clip
import androidx.compose.ui.graphics.Color
import androidx.compose.ui.text.font.FontWeight
import ru.chm.gradereport.ui.theme.GradeTheme
import androidx.compose.ui.unit.dp
import androidx.compose.ui.unit.sp
import ru.chm.gradereport.ui.screens.course.trimScore

/** Purple accent for cells with at least one attached submission (from forms). */
internal val SubmissionAccent = Color(0xFFA855F7)

@Composable
internal fun GradeCell(
    grade: Double?,
    hasSubmission: Boolean,
    editable: Boolean,
    onClick: () -> Unit,
) {
    val colors = GradeTheme.colors
    val shape = RoundedCornerShape(10.dp)
    val bg = if (hasSubmission) SubmissionAccent.copy(alpha = 0.18f) else colors.gradeCellBg
    val border = if (hasSubmission) SubmissionAccent.copy(alpha = 0.6f) else colors.gradeCellBorder
    Box(
        modifier = Modifier
            .requiredWidth(ColMark)
            .padding(6.dp)
            .height(48.dp)
            .clip(shape)
            .background(bg, shape)
            .border(1.dp, border, shape)
            .clickable(enabled = editable, onClick = onClick),
        contentAlignment = Alignment.Center,
    ) {
        Text(
            grade?.let { trimScore(it) } ?: "—",
            color = gradeColorOrMuted(grade),
            fontWeight = FontWeight.Bold,
            fontSize = 22.sp,
        )
    }
}
